/**
 * Avatar Utility Functions
 *
 * Handles avatar URL generation with fallback to initials
 */

/**
 * Get user initials from name or email
 */
export function getUserInitials(user: {
  firstName?: string | null;
  lastName?: string | null;
  name?: string;
  email?: string;
}): string {
  // Try to get initials from first and last name
  if (user.firstName && user.lastName) {
    return `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase();
  }

  if (user.firstName) {
    return user.firstName.charAt(0).toUpperCase();
  }

  // Try to get from full name string
  if (user.name) {
    const nameParts = user.name.trim().split(/\s+/);
    if (nameParts.length >= 2) {
      return `${nameParts[0].charAt(0)}${nameParts[nameParts.length - 1].charAt(0)}`.toUpperCase();
    }
    if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    }
  }

  // Fallback to email
  if (user.email) {
    return user.email.charAt(0).toUpperCase();
  }

  return "U";
}

/**
 * Get avatar URL for display in components
 * Returns the avatar URL if available, otherwise returns null for initials display
 */
export function getAvatarUrlOrNull(user: {
  avatar?: string | null;
  avatarUrl?: string | null;
}): string | null {
  const fromAvatar: string =
    typeof user.avatar === "string" ? user.avatar.trim() : "";

  if (fromAvatar.length > 0) {
    return fromAvatar;
  }

  const fromAvatarUrl: string =
    typeof user.avatarUrl === "string" ? user.avatarUrl.trim() : "";
  if (fromAvatarUrl.length > 0) {
    return fromAvatarUrl;
  }

  return null;
}
